import BaseClient from '@/app/model/api/response/baseApiClient'

class LinkImgDeleteApi extends BaseClient {
  public doLinkImgDelete () {
    const path: string = '/v1/file/planting-link-icon'

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new LinkImgDeleteApi()
